import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
export function SearchMarketCardSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="aspect-square w-full rounded-xlarge" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton typo="body4" className="w-100 rounded-xxsmall" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4"><Skeleton className="h-20 w-full rounded-xxsmall" /><Skeleton className="h-20 w-3/4 rounded-xxsmall" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div role="status" aria-label={"\uD2B9\uC0B0\uD488 \uB85C\uB529 \uC911"} className="flex flex-col gap-8">{t0}<div className="flex flex-col gap-8">{t1}{t2}<div className="flex flex-col gap-2"><Skeleton typo="body4" className="w-80 rounded-xxsmall" /><Skeleton typo="body2" className="w-3/4 rounded-xxsmall mobile-tablet:typo-body3" /></div><Skeleton typo="body3" className="w-80 rounded-xxsmall mobile-tablet:typo-body4" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
interface SearchMarketCardSkeletonListProps {
  count: number;
}
export function SearchMarketCardSkeletonList(t0) {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <ul aria-busy="true" className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:grid-cols-2 mobile-tablet:px-20">{Array.from({
        length: count
      }, _temp)}</ul>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return <li key={index}><SearchMarketCardSkeleton /></li>;
}